import $ from '@ali/tarzan-zepto';
import BaseUI from '../../baseui/index';

export default class {
  constructor(view, name) {
    this.view = view;
    this.bubbleList = [];
    this.name = name || 'robot';
  }

  init() {
    const gifSrc = '//laz-img-cdn.alicdn.com/tfs/TB1YERDfzTpK1RjSZKPXXa3UpXa-134-84.gif';
    const loadingTpl = `<img style="width:2.5em;margin-bottom:-6px;" src="${gifSrc}" />`;
    const param = {
      name: this.name,
      content: loadingTpl,
      side: 'left card-loading',
    };

    const $el = $(BaseUI.msg(param));
    this.view.body.append($el);

    this.bubbleList.push($el);
  }

  load($node, isSlideUp = false) {
    const bubbleAmount = this.bubbleList.length;
    if (bubbleAmount === 0) {
      this.init();
    }
    const $el = this.bubbleList.shift();

    if (isSlideUp) {
      this.__slideupMsg($el, $node);
    } else this.__appendMsg($el, $node);
  }

  __emptyBubbleAndAppendNode($el, $node) {
    // 把class置空，避免出现两层m-chatpanel-item，影响样式
    $el.attr('class', '');
    $el.addClass('bubble-left');
    // Android版不添加动效
    if (navigator.userAgent.indexOf('Android') === -1) {
      $el.addClass('bubble-up-from-left');
    }
    // 往loading里append真实的内容node
    $el.empty();
    if ($node) $el.append($node);
    // 重置iscroll高度，并判断是否需要滚动到底部
    this.__refreshUI();
    if ($node) {
      // 图片加载完需要再滚动到底部
      $node.find('img').on('load', () => {
        this.__refreshUI();
      });
    }
    // 清空气泡
    this.__emptyBubbleList();
  }

  __slideupMsg($el, $node) {
    this.view.$frame.append($node);
    this.__emptyBubbleAndAppendNode($el);
  }

  __appendMsg($el, $node) {
    this.__emptyBubbleAndAppendNode($el, $node);
  }

  __emptyBubbleList() {
    const bubbleAmount = this.bubbleList.length;
    if (bubbleAmount !== 0) {
      this.bubbleList.forEach(() => {
        this.remove();
      });
    }
  }

  __refreshUI() {
    /**
     * 只有页面本身在底部的时候，需要滚动到底部
     * 反例，用户在看历史消息，这时候小二发了消息，不应该直接滚到到底部，而是出现新消息提醒
     */
    if (this.view.body.isBottom()) {
      this.view.body.scrollToBottom();
    } else {
      this.view.body.refresh();
    }
  }

  remove() {
    const $el = this.bubbleList.shift();
    if ($el) {
      $el.addClass('fade-out-to-bottom');
      $el.remove();
      this.view.body.scrollToBottom();
      setTimeout(() => {
      }, 1500);
    }
  }

  fail() {
    // TODO 加载失败消息
  }
}



// WEBPACK FOOTER //
// ./src/component/view/message_loading/index.js